import { Box, Typography, Link, Stack, useTheme, useMediaQuery } from "@mui/material";

export default function Footer({ drawerWidth, open }) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <Box
            component="footer"
            sx={{
                mt: "auto",
                px: 3,
                py: 2,
                borderTop: "1px solid rgba(255,255,255,0.08)",
                backgroundColor: "#020617",
                ml: !isMobile && open ? `${drawerWidth}px` : 0,
                width: !isMobile && open
                    ? `calc(100% - ${drawerWidth}px)`
                    : "100%",
                transition: theme =>
                    theme.transitions.create(["margin-left", "width"], {
                        easing: theme.transitions.easing.sharp,
                        duration: theme.transitions.duration.standard
                    })
            }}
        >
            <Box
                sx={{
                    maxWidth: "100%",
                    display: "flex",
                    flexDirection: {
                        xs: "column",
                        md: "row",
                    },
                    alignItems: {
                        xs: "flex-start",
                        md: "center",
                    },
                    justifyContent: "space-between",
                    gap: 1,
                }}
            >
                <Typography
                    variant="body2"
                    sx={{ color: "#94a3b8" }}
                >
                    © 2024 - {new Date().getFullYear()} <b>ItzamLabs</b> by <i>FeatureDevs</i>. Todos los derechos reservados.
                </Typography>
                <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                        order: {
                            xs: 3,
                            md: 2,
                        },
                    }}
                >
                    <Link href="#" underline="hover" sx={{ color: "#64748b" }}>
                        Soporte
                    </Link>
                    <Link href="#" underline="hover" sx={{ color: "#64748b" }}>
                        Privacidad
                    </Link>
                </Stack>
                <Typography
                    variant="caption"
                    sx={{
                        color: "#64748b",
                        order: {
                            xs: 2,
                            md: 3,
                        },
                    }}
                >
                    v1.0.0
                </Typography>
            </Box>
        </Box>
    );
}
